import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseurlService} from '../../services/baseurl.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StracliCmdService {

  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) { }

  getHosts(): Observable<Array<StracliPongDto>> {
    return this.http.get<Array<StracliPongDto>>(`${this.baseurlService.getBaseUrl()}/stracliCommands/hosts`);
  }

  getResponses(): Observable<Array<StracliCmdResponsePersistenceEntity>> {
    return this.http.get<Array<StracliCmdResponsePersistenceEntity>>(`${this.baseurlService.getBaseUrl()}/stracliCommands/stracliCmdResponses`);
  }

  getStracliCmdResponse(id: number): Observable<StracliCmdResponsePersistenceEntity> {
    return this.http.get<StracliCmdResponsePersistenceEntity>(`${this.baseurlService.getBaseUrl()}/stracliCommands/stracliCmdResponses/${id}`);
  }

  runCommand(host: string, type: StracliCommandType, additional: AdditionalDataStracliCommand): Observable<void> {
    return this.http.post<void>(`${this.baseurlService.getBaseUrl()}/stracliCommands/execute/${host}/type/${type}`, additional);
  }
}

export interface StracliCmdResponsePersistenceEntity {
  id: number | null;
  stracliCommandUid: string;
  responseEntityCreated: string;
  commandCreatedCreated: string | null;
  commandReceived: string | null;
  commandPerformed: string | null;
  type: StracliCommandType;
  response: StracliCmdResponse;
}

export interface StracliCmdResponse {
  uid: string;
  type: StracliCommandType;
  typeSpecificResponse: string;
  cmdSent: string | null;
  cmdReceived: string | null;
  cmdPerformed: string | null;
}

export interface StracliCmdResponseSpel {
  responseString: string | null;
  responseJson: string | null;
}

export interface StracliCmdResponseScreenshotStream {
  host: string;
  streaming: boolean;
  screenAvailable: boolean;
  intervalMillis: number;
}

export interface StracliCmdResponseQwen {
  exitCode: number;
  stdout: string;
  stderr: string;
  terminatedOnItsOwn: boolean;
}

export interface ShellExecStatus {
  exitCode: number;
  stdout: string;
  stderr: string;
  terminatedOnItsOwn: boolean;
}

export interface StracliPongDto {
  host: string;
  time: string;
  commitId: string | null;
  commitsBehind: number | null;
  buildTimestamp: string | null;
  javaClassVersion: string | null;
  javaSpecificationVersion: string | null;
  osName: string | null;
  osVersion: string | null;
  ignoreMonitoring: boolean;
  javaRuntimeVersion: string | null;
  javaVendor: string | null;
}

export enum StracliCommandType {
  DUMMY = 'DUMMY',
  SHUTDOWN = 'SHUTDOWN',
  SPEL = 'SPEL',
  BASH = 'BASH',
  CMD = 'CMD',
  POWERSHELL = 'POWERSHELL',
  QWEN = 'QWEN',
  AI = 'AI',
  START_SCREENSHOT_STREAM = 'START_SCREENSHOT_STREAM',
  END_SCREENSHOT_STREAM = 'END_SCREENSHOT_STREAM',
}

export interface AdditionalDataStracliCommand {
  text?: string | null;
}
